// src/functions.ts
var camelizeFromPascal = (text) => {
  if (!text)
    return "";
  return text.replace(/^[A-Z]/, (match) => match.toLowerCase());
};
var jsonToBase64 = (json) => {
  const jsonString = JSON.stringify(json);
  const bytes = new TextEncoder().encode(jsonString);
  const base64String = btoa(String.fromCharCode(...bytes));
  return base64String;
};
var base64ToJson = (base64) => {
  try {
    const jsonString = atob(base64);
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error decoding base64 or parsing JSON", error);
    return null;
  }
};

export {
  camelizeFromPascal,
  jsonToBase64,
  base64ToJson
};
